/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateGuardianDto } from '../../models/create-guardian-dto';

export interface ParentGuardianControllerConnectChildParent$Params {
  childIdList: Array<string>;
      body: CreateGuardianDto
}

export function parentGuardianControllerConnectChildParent(http: HttpClient, rootUrl: string, params: ParentGuardianControllerConnectChildParent$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
  const rb = new RequestBuilder(rootUrl, parentGuardianControllerConnectChildParent.PATH, 'patch');
  if (params) {
    rb.query('childIdList', params.childIdList, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: String((r as HttpResponse<any>).body) === 'true' }) as StrictHttpResponse<boolean>;
    })
  );
}

parentGuardianControllerConnectChildParent.PATH = '/api/guardian/parent/connect';
